export const getCachedSelectedLanguage = (): string | null => {
  return localStorage.getItem('i18nextLng');
};

export const cacheSelectedLanguage = (value: string): void => {
  localStorage.setItem('i18nextLng', value);
};
